import { VssPersona } from 'azure-devops-ui/VssPersona';
import React from 'react';
import { Persona } from '../../../clients/ogg';

export default function PersonaRow(persona: Persona) {
  return (
    <div className='list-row flex-row h-scroll-hidden'>
      <div className='flex-row flex-center'>
        <VssPersona
          identityDetailsProvider={{
            getDisplayName() {
              return persona.name;
            },
            getIdentityImageUrl(size: number) {
              return undefined;
            },
          }}
          size={'medium'}
        />
      </div>
      <div
        style={{ marginLeft: '10px', padding: '10px 0px' }}
        className='flex-column h-scroll-hidden'
      >
        <span className='wrap-text'>{persona.name}</span>
        <span className='fontSizeMS font-size-ms secondary-text wrap-text'>
          {persona.description}
        </span>
      </div>
    </div>
  );
}
